import React from 'react';
import CoreComponent from "../../../../Core/CoreComponent";
import Theme from '../../../../Themes/ThemeArtLexie'
import Settings from '../../Settings/Settings';
import Style from './Styles/LoginPaperStyle'
import Appbar from '../Appbar/Appbar';
import LoginPaper from './Subcomponents/LoginPaper'
import Paper from '@mui/material/Paper';
export default class LoginComponent extends CoreComponent {

    constructor(props) {
        super(props);
        this.loadComponentsProps()
        this.basicComponentConstants = {
            language: props.getManagerState().language,
            urlParams: this.props.urlParams
        }
    }

    componentDidMount() {
        super.componentDidMount()
        if (this.getLocalStorage('user')) {
            this.props.changeRoute('/');
        }
    }
    loadComponentsProps() {
        const that = this
        this.setComponentsConstants('Appbar', {
            ...this.basicComponentConstants
        }).setComponentsMethods('Appbar', {
            setManagerState: (object, callback) => {
                that.props.setManagerState(object, callback)
            },
            refreshMainComponent: () => {
                that.refresh()
            },
            getManagerState: () => {
                return that.props.getManagerState()
            },
            changeRoute: (route) => {
                that.props.changeRoute(route)
            },
            getLocalStorage: (storageName) => {
                return that.getLocalStorage(storageName)
            },
            clearErrorMessage: (index) => {
                that.props.clearErrorMessage(index)
            },
            ajax: (url, 
                dataObject = {}, 
                method, stateValue = '', 
                callback = () => {}, 
                headers = {}, 
                setState = true, 
                catchCallback = () => {}) => {
                    that.ajax (url, 
                        dataObject, 
                        method, stateValue, 
                        callback, 
                        headers, 
                        setState, 
                        catchCallback);
                },
            addError: (errorMessage, stateObject) => {
                that.addErrorMain(errorMessage, stateObject)
            },
            setSuccessfulUsersLogIn : (data) => {
                that.setSuccessfulUsersLogIn(data)
            },
            setLogInErrors: (data) => {
                that.setLogInErrors(data)
            },
            showRecoverPasswordScreen: () => {
                that.props.setManagerState({recoverPasswordScreen: true})
            },
            hideRecoverPasswordScreen: () => {
                that.props.setManagerState({recoverPasswordScreen: false})
            },
            changeRoute: (route) => {
                that.props.changeRoute(route)
            }
        })
    }
    setLogInErrors(data) {
        let invalidFields = {}
        let errorMessage = [this.props.getManagerState().language[data.message] ]
            invalidFields.formInvalidLogInUsersEmail = true;
            invalidFields.formInvalidLogInPassword= true;
        if(data.fields.usersEmail) {
            errorMessage.push(this.props.getManagerState().language["LANG_usersEmail"] + ': ' + this.props.getManagerState().language[data.fields.usersEmail.message])
        }

        if(data.fields.usersPassword) {
            errorMessage.push(this.props.getManagerState().language["LANG_usersPassword"] + ': ' + this.props.getManagerState().language[data.fields.usersPassword.message])
        }
        this.addErrorMain(errorMessage.join(', '), invalidFields)
        this.props.setManagerState({loadingLogin: false})
    }
    setSuccessfulUsersLogIn(data) {
        const that = this;
        this.isLoggedInUser(() => {this.setUserData(this.props)})
        this.saveLocalStorage(data.items[0], 'user')
        this.props.setManagerState({loadingLogin: false}, () => {
            that.mergeShoppingCart()
        })
    } 
    
    postShoppingCartAction() {
        const that = this
        let accessToken = ''
        if(this.getLocalStorage('user')) {
            accessToken = '?accountToken=' + this.getLocalStorage('user').tokensHash
        }
        if(!this.props.getManagerState().loadingPostShoppingCart) {
            this.props.setManagerState({loadingPostShoppingCart: true}, () => {
                this.ajax(Settings.API_URL + Settings.API_ENDPOINT_SHOPPINGCART + accessToken,{},'POST',null, (data) => {
                    that.saveLocalStorage(data.items[0], 'shoppingCart')
                    that.props.setManagerState({loadingPostShoppingCart: false})
                    that.props.changeRoute('/')
                })
            })    
        }
    }

    mergeShoppingCart() {
        let that = this
        let url = Settings.API_URL + Settings.API_ENDPOINT_SHOPPINGCART_MERGE + that.getLocalStorage('shoppingCart').shoppingCartSha
        let accountToken = '?accountToken=' + that.getLocalStorage('user').tokensHash
        if (!this.props.getManagerState().loadingMergeShoppingCart) {
            this.props.setManagerState({loadingMergeShoppingCart: true}, () => {
                that.ajax(url += accountToken, 
                    {}, 
                   "GET", 'shoppingCartItems', 
                    (data) => {
                       that.postShoppingCartAction()
                       that.props.setManagerState({loadingMergeShoppingCart : false})
                   })
                })
        };
    }
    getRender() {
        const classes = Style();
        this.loadComponentsProps()
        return <Paper style={classes.rootPaper}>
                    <div style={classes.root}>
                    <Appbar {...this.buildComponentProps('Appbar')} />
                    <div style={classes.pageContainer}>
                        <LoginPaper {...this.buildComponentProps('Appbar')} />
                    </div>
                </div>
                </Paper>
    }
}
